module.exports = __webpack_public_path__ + "static/media/uploadSpreadsheet.26e9e447.svg";